<i class="material-icons">delete</i>
<div class="space"></div>
<ng-container i18n>Deleted</ng-container>
<button class="message-user-delete-reset-action" (click)="action()" i18n>Undo</button>
